import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Reprint by xlsx',
      title: 'Reprint by xlsx',
      executeAction: 'Send',
      resetAction: 'Reset',
      errorMessage: 'Error',
      nothingToCreate: 'Not created any print journal',
      fields: {
        file: 'File',
        label: 'Template',
      },
    }
  }
}